import EmblaCarousel from "embla-carousel";
import { addPrevNextButtonClickHandlers } from "embla-arrow";
import { initEmblaProgress } from "@theme/base";

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.emblaApi = null;
    this.initialized = false;
    this.resizeObserver = null;
    this.resizeTimeout = null;
  }

  connectedCallback() {
    const wrapperNode = this.querySelector(".embla");

    if (wrapperNode) {
      const viewportNode = wrapperNode.querySelector(".embla__viewport");
      const prevBtn = wrapperNode.querySelector(".embla__prev");
      const nextBtn = wrapperNode.querySelector(".embla__next");
      const dotsNode = wrapperNode.querySelector(".embla__dots");

      this.containerNode = wrapperNode.querySelector(".embla__container");

      if (this.containerNode) {
        this.mobileSlide = this.containerNode.querySelector(".js-mobile-only");
        if (this.mobileSlide) {
          this.slideIndex = Array.from(this.containerNode.children).indexOf(
            this.mobileSlide,
          );
        }
      }

      if (typeof EmblaCarousel === "function") {
        // Definiamo una funzione interna per gestire l'inizializzazione/aggiornamento
        const initOrUpdateCarousel = () => {
          const isDesktop = window.innerWidth >= 1280; // Breakpoint 'lg' di Tailwind

          if (this.mobileSlide) {
            const slideInDom = this.containerNode.contains(this.mobileSlide);

            if (isDesktop && slideInDom) {
              // Rimuove fisicamente la slide se siamo su desktop
              this.mobileSlide.remove();
            } else if (!isDesktop && !slideInDom) {
              // Ripristina la slide nella sua esatta posizione originale se siamo su mobile
              if (this.slideIndex >= this.containerNode.children.length) {
                this.containerNode.appendChild(this.mobileSlide);
              } else {
                this.containerNode.insertBefore(
                  this.mobileSlide,
                  this.containerNode.children[this.slideIndex],
                );
              }
            }
          }

          // Se Embla è già attivo, lo distruggiamo prima di ricrearlo con i nodi aggiornati
          if (this.emblaApi) {
            this.emblaApi.destroy();
          }

          this.emblaApi = EmblaCarousel(viewportNode, { loop: true });
          if (dotsNode) dotsNode.innerHTML = "";
          addPrevNextButtonClickHandlers(this.emblaApi, prevBtn, nextBtn);

          initEmblaProgress(
            viewportNode,
            this.emblaApi,
            viewportNode
              .closest(".product_card")
              .querySelector(".progress-carousel"),
          );

          this.initialized = true;
        };

        const setupResizeObserver = () => {
          this.resizeObserver = new ResizeObserver(() => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => initOrUpdateCarousel(), 150);
          });
          this.resizeObserver.observe(this);
        };

        const init = () => {
          if (!this.initialized) {
            initOrUpdateCarousel();
            setupResizeObserver();
          }
        };

        const isDesktop = () => window.innerWidth >= 1280;

        if (isDesktop()) {
          this.addEventListener("mouseenter", init, { once: true });
        } else {
          const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              init();
              observer.disconnect();
            }
          }, { threshold: 0.1 });
          observer.observe(this);
        }
      }
    }
  }

  disconnectedCallback() {
    if (this.emblaApi) {
      this.emblaApi.destroy();
      this.emblaApi = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    clearTimeout(this.resizeTimeout);
  }
}

customElements.define("product-card", ProductCard);
